import { render, staticRenderFns } from "./CurrentEmailDetailsForm.vue?vue&type=template&id=ed05a4ae"
import script from "./CurrentEmailDetailsForm.vue?vue&type=script&lang=ts"
export * from "./CurrentEmailDetailsForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports